<script lang="ts">
	import { run } from 'svelte/legacy';

	import { cubicInOut } from 'svelte/easing';
	import { fade } from 'svelte/transition';
	import { isMobileDevice } from './common';
	import { flyAndScale } from './animations';
	import { createDialog, createSync, melt } from '@melt-ui/svelte';
	import IconCross from '$lib/icons/IconCross.svelte';

	interface Props {
		paddingAndMarginMobile?: boolean;
		paddingAndMargin?: boolean;
		classs?: string;
		open?: boolean;
		role?: 'dialog' | 'alertdialog';
		closeButton?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		paddingAndMarginMobile = true,
		paddingAndMargin = true,
		classs = 'max-w-2xl',
		open = $bindable(false),
		role = 'dialog',
		closeButton = false,
		children,
	}: Props = $props();

	const {
		elements: { trigger, portalled, overlay, content, title: meltTitle, description, close },
		states,
	} = createDialog({
		role,
		closeOnOutsideClick: !isMobileDevice(),
	});

	const sync = createSync(states);
	// Whenever the open prop changes, update the local state, and vice versa
	run(() => {
		sync.open(open, (value) => (open = value));
	});
</script>

{#if open}
	<div use:melt={$portalled} class="absolute left-0 top-0 z-10 flex h-full w-full flex-col items-center justify-center">
		<div
			use:melt={$overlay}
			in:fade={{ duration: 180, easing: cubicInOut }}
			out:fade={{ duration: 250, easing: cubicInOut }}
			class="fixed inset-0 overflow-y-auto bg-gray-950 bg-opacity-80"
		></div>
		<div
			class="flex min-h-full items-center justify-center text-center"
			class:sm:p-4={paddingAndMargin}
			class:p-4={paddingAndMarginMobile && paddingAndMargin}
		>
			<div
				use:melt={$content}
				transition:flyAndScale={{ duration: 190, y: 8, start: 0.9 }}
				class="max-h-dvh w-full transform overflow-auto rounded-md bg-white text-left align-middle shadow-xl transition-all {classs}"
			>
				{#if closeButton}
					<div class="relative">
						<button
							use:melt={$close}
							type="button"
							aria-label="Close"
							class=" relative float-right m-4 inline-flex appearance-none items-center justify-center rounded-full text-violet-800 hover:bg-violet-100 focus:shadow-violet-400"
						>
							<IconCross class="size-7"></IconCross>
						</button>
					</div>
				{/if}
				<div class="" class:sm:p-8={paddingAndMargin} class:p-4={paddingAndMarginMobile && paddingAndMargin}>
					{@render children?.()}
				</div>
			</div>
		</div>
	</div>
{/if}
